// Antispam
function antispam() {
    $('.js-antispam').each(function (){
        var spamValue = $(this).find('input').data('value');
        
        $(this).hide();
        $(this).find('input').val(spamValue);
    });

}